'use strict';

var _ = require('lodash');
var NewCalendarService = function NewCalendarService($q, restangular, configurationService, seasonalityConstants, DowGroup, UserSecureService) {
  var apiUrl = '/partitioned/seasonality/request';
  var pooledApiUrl = '/pooled/seasonality/request';
  var publishUrl = '/pooled/seasonality/publish?clearDemandAdjustments=';
  function getServiceUrl(isPooledDemandCalendar) {
    if (isPooledDemandCalendar) {
      return restangular.service(pooledApiUrl);
    } else {
      return restangular.service(apiUrl);
    }
  }
  function getPublishUrl(clearDemandAdjustments) {
    return restangular.service(publishUrl + clearDemandAdjustments);
  }
  function getOriginAndDestination(marketString) {
    return _.split(marketString, '-');
  }
  function convertSpecialEvents(specialEvents, market) {
    return _.chain(specialEvents).filter(function (event) {
      return _.replace(event.market, '-', '') === market;
    }).transform(function (result, event) {
      return result.push({
        market: _.replace(event.market, '-', ''),
        startDepartureDate: event.startDateMoment.toISOString(),
        endDepartureDate: event.endDateMoment.toISOString(),
        eventName: event.name,
        eventType: event.type
      });
    }).value();
  }
  function convertSpecialEventsForPooledSeasonality(specialEvents) {
    return _.chain(specialEvents).transform(function (result, event) {
      return result.push({
        market: _.replace(event.market, '-', ''),
        startDepartureDate: event.startDateMoment.toISOString(),
        endDepartureDate: event.endDateMoment.toISOString(),
        eventName: event.name,
        eventType: event.type
      });
    }).value();
  }
  function convertDowGroups(dowGroups) {
    var res = [];
    var days = [];
    _.forEach(dowGroups, function (dowGroup) {
      var dow = [];
      days = _.union(days, dowGroup.days);
      _.forEach(dowGroup.days, function (day) {
        dow.push(_.capitalize(day));
      });
      res.push({
        group: dowGroup.getName(),
        dow: dow
      });
    });

    //miss some dowGroup
    if (days.length < 7) {
      var missDowGroup = new DowGroup({
        days: _.difference(['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'], days)
      });
      var dow = [];
      _.forEach(missDowGroup.days, function (day) {
        dow.push(_.capitalize(day));
      });
      res.push({
        group: missDowGroup.getName(),
        dow: dow
      });
    }
    return res;
  }
  function sendNewCalendarRequest(calendar, isPooledDemandCalendar) {
    var requests = [];
    if (isPooledDemandCalendar) {
      requests = prepareRequestsForPooledSeasonality(calendar);
    } else {
      requests = prepareRequests(calendar);
    }
    var requestPromises = [];
    if (isPooledDemandCalendar) {
      requestPromises.push(getServiceUrl(isPooledDemandCalendar).post(requests));
    } else {
      _.forEach(requests, function (request) {
        requestPromises.push(getServiceUrl(isPooledDemandCalendar).post(request));
      });
    }
    return $q.all(requestPromises);
  }
  function publishPooledSeasonalityCalendars(selectedRows, clearDemandAdjustments) {
    var requests = prepareRequestsForPooledSeasonalityPublish(selectedRows);
    var requestPromises = [];
    requestPromises.push(getPublishUrl(clearDemandAdjustments).post(requests));
    return $q.all(requestPromises);
  }
  function prepareRequests(calendar) {
    return _.chain(calendar.selectedMarkets).filter({
      selected: true
    }).map(function (selectedMarket) {
      var market = selectedMarket.market;
      var originAndDestination = getOriginAndDestination(market);
      return {
        calendarName: calendar.name.trim(),
        marketRTPWeights: [{
          origin: originAndDestination[0],
          destination: originAndDestination[1],
          rtpWeightMap: {
            '0d 0h 0m': 1
          }
        }],
        startDepartureDate: calendar.dateRangeFrom.toISOString(),
        endDepartureDate: calendar.dateRangeTo.toISOString(),
        seasonalityVariable: seasonalityConstants.METRICS_TO_SEASONALITY_VARIABLE[calendar.metric.label],
        domainName: calendar.domainName,
        dowGroups: convertDowGroups(calendar.dowGroups),
        specialEvents: convertSpecialEvents(calendar.eventsForSubmit, _.replace(market, '-', '')),
        //special event grid hasn't been implemented yet
        carrier: configurationService.getHostCarrier(),
        seasonalityLevel: seasonalityConstants.LEVEL_TO_SEASONALITY_LEVEL[calendar.level],
        minOptimalSeasons: calendar.minNumberOfSeasons.id,
        maxOptimalSeasons: calendar.maxNumberOfSeasons.id,
        outlierTolerance: calendar.outlierTolerance,
        optimalSeasonCutoffCV: calendar.minDevBetweenSeasons,
        smoothingNumberOfWeeks: calendar.smoothingNumberOfWeeks.id,
        user: UserSecureService.getUserId()
      };
    }).value();
  }
  function prepareRequestsForPooledSeasonality(calendar) {
    return {
      seasonalityProfile: calendar.name.trim(),
      startDate: calendar.dateRangeFrom.format('YYYY-MM-DD'),
      endDate: calendar.dateRangeTo.format('YYYY-MM-DD'),
      markets: _.map(_.filter(calendar.selectedMarkets, {
        selected: true
      }), 'market'),
      carrier: configurationService.getHostCarrier(),
      specialEvents: convertSpecialEventsForPooledSeasonality(calendar.eventsForSubmit),
      outlierTolerance: calendar.outlierTolerance,
      learningProcess: calendar.learningProcess.id,
      isLearning: false,
      regressionTerms: calendar.regressionTerms.id,
      user: UserSecureService.getUserId()
    };
  }
  function prepareRequestsForPooledSeasonalityPublish(selectedRows) {
    var requestParams = {
      queueElements: []
    };
    _.forEach(selectedRows, function (row) {
      var request = {
        marketOrigin: row.market.split('-')[0],
        marketDestination: row.market.split('-')[1],
        carrier: configurationService.getHostCarrier(),
        calendarName: row.calendarName
      };
      requestParams.queueElements.push(request);
    });
    return requestParams;
  }
  function validateCalendarName(calendarName) {
    return calendarName.length >= 6 && calendarName.length <= 50;
  }
  function validateSpecialEvents(specialEvents) {
    var flag = '_clear';
    _.forEach(specialEvents, function (event) {
      if (event.name === null || event.market === null || event.type === null || event.startDateMoment === null || event.endDateMoment === null) {
        flag = 'One or more properties of the special events created are empty, please enter valid values and continue';
      }
    });
    return flag;
  }
  function doEventsOverlap(event, comparedEvent) {
    var eventStart = event.startDateMoment;
    var eventEnd = event.endDateMoment;
    var comparedEventStart = comparedEvent.startDateMoment;
    var comparedEventEnd = comparedEvent.endDateMoment;
    var isStartWithin = comparedEventStart.isBefore(eventEnd) && comparedEventStart.isAfter(eventStart);
    var isEndWithin = comparedEventEnd.isBefore(eventEnd) && comparedEventEnd.isAfter(eventStart);
    return isStartWithin || isEndWithin;
  }
  function validateSpecialEventsDates(specialEvents) {
    var errorEventName;
    var errorMarket;
    var overlappingEventName;
    if (specialEvents.length <= 1) {
      return '_clear';
    }
    for (var i = 0; i < specialEvents.length; i++) {
      var event = specialEvents[i];
      for (var j = 0; j < specialEvents.length; j++) {
        var comparedEvent = specialEvents[j];
        if (j === i || comparedEvent.market !== event.market) {
          continue;
        }
        if (doEventsOverlap(event, comparedEvent)) {
          errorEventName = event.name;
          overlappingEventName = comparedEvent.name;
          errorMarket = event.market;
          break;
        }
      }
      if (overlappingEventName) {
        break;
      }
    }
    return overlappingEventName ? errorEventName + ' has date range overlapping with ' + overlappingEventName + ' for market: ' + errorMarket : '_clear';
  }
  return {
    sendNewCalendarRequest: sendNewCalendarRequest,
    publishPooledSeasonalityCalendars: publishPooledSeasonalityCalendars,
    validateSpecialEventsDates: validateSpecialEventsDates,
    validateCalendarName: validateCalendarName,
    validateSpecialEvents: validateSpecialEvents
  };
};
NewCalendarService.$inject = ['$q', 'Restangular', 'ConfigurationService', 'SeasonalityConstants', 'DowGroupFactory', 'UserSecureService'];
module.exports = NewCalendarService;